var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-3"},[_c('form',[_c('label',[_vm._v(_vm._s(_vm._f("setText")('import_students_notice','Импорт учеников EXCEL. После загрузки документа - операция добавления учеников может занять от 1 минуты до 5')))]),_c('br'),_c('input',{ref:"fileupload",attrs:{"type":"file","accept":".xlsx"},on:{"input":_vm.importItem}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }